import { colors } from '../../../designTokens';

/**
 * Title: line-clamp only (no min-height) so short titles sit tight to the description.
 * Description: fixed line clamp + height so author/stats rows align across cards.
 */

export function libraryCardTitleSlotSx() {
  return {
    flexGrow: 1,
    mr: 1,
    m: 0,
    fontSize: '1rem',
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: 1.35,
    minHeight: '2.7rem',
    maxHeight: '2.7rem',
    color: colors.textPrimary,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    wordBreak: 'break-word',
  };
}

export function libraryCardDescriptionSlotSx(compact) {
  const lineHeight = 1.45;
  const fontSize = compact ? '0.71875rem' : '0.78125rem';
  const clampLines = compact ? 1 : 2;
  const blockHeight = `calc(${fontSize} * ${lineHeight} * ${clampLines})`;

  return {
    mb: compact ? 2 : 2.5,
    fontSize,
    fontWeight: 400,
    color: colors.description,
    lineHeight,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: clampLines,
    overflow: 'hidden',
    wordBreak: 'break-word',
    minHeight: blockHeight,
    maxHeight: blockHeight,
  };
}

export const libraryCardAuthorSx = {
  fontSize: '0.8125rem',
  fontWeight: 500,
  color: colors.textSecondary,
  lineHeight: 1.4,
};

export const libraryCardMetaSx = {
  fontSize: '0.75rem',
  fontWeight: 400,
  color: colors.textMuted,
  lineHeight: 1.4,
};
